<template>
  <div class="review-analysis">
    <gj-analysis-panel
        :title="'Review分析'"
    >
      <template #subtitle>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh']"
            @refresh="refresh"
        />
      </template>
      <template #panelBody>
        <ReviewAnalysisHeader :loading="loading" :data="reviewAnalysisData"/>
        <div class="review-analysis-content" v-loading="loadingBottom">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-card class="box-card">
                <Chart :type="'bar'" :option="orderSiteDistributionOption"/>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import Chart from "@/views/components/chart/chart"
import ReviewAnalysisHeader from "@/views/components/option-header/review-analysis-header"
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {getReviewAnalyseData,getReviewChartData} from "@/api/statistics"
import _ from "lodash";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";

export default {
  name: "review-analysis",
  components: {  Chart, ReviewAnalysisHeader,OptionGroup},
  inject: ['getPageParams'],
  computed: {
   startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    },
  },
  data(){
    return{
      useCache: false,
      loading: false,
      loadingBottom: false,
      orderSiteDistributionOption: {},
      reviewAnalysisData: {},
      reviewAnalysisxAxis: [],
      reviewAnalysisSeries: [],
    }
  },
  mounted() {
    this.initOrderSiteDistributionOptionParams();
    this.$gjQuery()
  },
  methods: {
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      this.getReviewAnalyseData();
      this.getReviewChartData();
    },
    /**
     * 刷新当前模块
     */
    refresh(){
      this.$gjQuery();
    },
    /**
     * 获取review分析数据统计
     */
    getReviewAnalyseData(){
      this.loading = true;
      const params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      };
      getReviewAnalyseData(params).then((res) =>{
        //拼装review分析数据,可以将原装数据传过去
        for(let key in res){
          res[key] = _.round(_.toNumber(res[key]), 2);
        }
        this.reviewAnalysisData = res;
      }).complete(()=>{
        this.loading = false;
      })
    },
    /**
     * 获取review分析统计图表
     */
    getReviewChartData(){
      this.loadingBottom = true;
      const params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      };
      getReviewChartData(params).then((res) =>{
        let data = res;
        //拼装review图表数据
        let axisData = [];
        let seriesDataOne = [];     //好评数
        let seriesDataTwo = [];     //中差评数
        let seriesDataThree = [];   //中差评率
        let yGoodReviewMax = 0, yNoReviewMax =0,yNoReviewRateMax = 0;
        for(let i=0;i<data.length;i++){
          yGoodReviewMax = yGoodReviewMax >_.toNumber(data[i].goodReview) ? yGoodReviewMax: _.toNumber(data[i].goodReview);
          yNoReviewMax = yNoReviewMax >_.toNumber(data[i].noReview) ? yNoReviewMax: _.toNumber(data[i].noReview);
          yNoReviewRateMax = yNoReviewRateMax >_.toNumber(data[i].noReviewRate) ? yNoReviewRateMax: _.toNumber(data[i].noReviewRate) ;
          axisData.push(data[i].countryCode);
          seriesDataOne.push(data[i].goodReview)
          seriesDataTwo.push(data[i].noReview)
          seriesDataThree.push(data[i].noReviewRate)
        }
        let reviewAnalysisxAxis = {
          type: 'category',
          data: axisData,
          // boundaryGap: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
          axisLabel: {
            margin: 10,
            color: "#32393d"
          },
        }
        let itemOne = {
          name: "好评数",
          type: 'bar',
          stack: 'review',
          barMaxWidth: "30",
          emphasis: {
            focus: 'series'
          },
          data: seriesDataOne
        };
        let itemTwo = {
          name: "中差评数",
          type: 'bar',
          stack: 'review',
          emphasis: {
            focus: 'series'
          },
          data: seriesDataTwo
        };
        let itemThree = {
          name: "中差评率",
          type: 'line',
          stack: 'review1',
          yAxisIndex: 1,
          emphasis: {
            focus: 'series'
          },
          data: seriesDataThree
        };
        this.reviewAnalysisxAxis = reviewAnalysisxAxis;
        this.reviewAnalysisSeries = _.concat([], [itemOne, itemTwo, itemThree]);
        this.initOrderSiteDistributionOptionParams(yGoodReviewMax, yNoReviewMax,yNoReviewRateMax, this.reviewAnalysisxAxis,this.reviewAnalysisSeries);
      }).complete(()=>{
        this.loadingBottom = false;
      })
    },
    initOrderSiteDistributionOptionParams(yGoodReviewMax = 0, yNoReviewMax =0,yNoReviewRateMax = 0, reviewAnalysisxAxis,reviewAnalysisSeries){
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter:function(params){
            let str = '';
            params.map((v,idx)=>{
              if(idx ===0){
                str += v.name + "<br/>";
              }
              str += v.marker + v.seriesName + ":    ";
              if(idx ===2){
                str += v.value +"%" + "<br/>";
              } else {
                str += v.value + "<br/>";
              }
            })
            return str;
          }
        },
        legend: {
          data: ['好评数', '中差评数', '中差评率'],
          top: '0%',
          itemGap: 10,
          icon: "rect",
          itemWidth: 15,
          itemHeight: 3,
          textStyle: {
            color: '#888',
            padding: [2, 0, 0, 0],
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: reviewAnalysisxAxis,
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              margin: 10,
              color: "#32393d"
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
            min: 0,
            interval: (yGoodReviewMax + yNoReviewMax)/5,
            max: yGoodReviewMax + yNoReviewMax
          },
          {
            type: 'value',
            axisLabel: {
              margin: 10,
              color: "#32393d",
              formatter: '{value} %'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
            min: 0,
            interval: 20,
            max: 100
          },
        ],
        color: ['#2DC079', '#FF5656', '#FA8955'],
        series: reviewAnalysisSeries
      };
      this.orderSiteDistributionOption = option;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../common/index.scss";
.review-analysis{
  margin-top: 10px;
  //padding: 80px 0px 0 0px;
  //margin-top: -80px;
}
.review-analysis-content{
  margin-top: 15px;
}
</style>
